<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitContactData"> 
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-12">
              <label class="form-label">{{ $t('settings.contacts.name') }}</label><span class="text-danger"> *</span>
              <base-input
                  :invalid="$v.formData.name.$error"
                  v-model="formData.name"
                  ref="name"
                  type="text"
                  name="name"
                  tab-index="1"
                  @input="$v.formData.name.$touch()"
              />
              <div v-if="$v.formData.name.$error">
                  <span v-if="!$v.formData.name.required" class="text-danger">
                    {{ $tc('validation.name_required') }}
                  </span>
                  <span v-if="!$v.formData.name.minLength" class="text-danger">
                    {{ $tc('validation.name_min_length', $v.formData.name.$params.minLength.min, { count: $v.formData.name.$params.minLength.min }) }}
                  </span>
              </div>
            </div>
            
            <div class="col-md-12 mt-3">
                <label class="form-label">{{ $t('settings.contacts.email') }}</label><span class="text-danger"> *</span>
                <base-input
                  :invalid="$v.formData.email.$error"
                  v-model.trim="formData.email"
                  type="text"
                  name="email"
                  tab-index="3"
                  @input="$v.formData.email.$touch()"
                />
                <div v-if="$v.formData.email.$error">
                  <span v-if="!$v.formData.email.email" class="text-danger">
                    {{ $tc('validation.email_incorrect') }}
                  </span>
                  <span v-if="!$v.formData.email.required" class="text-danger">
                    {{ $tc('validation.email_required') }}
                  </span>
                </div>
            </div>
            <div class="col-md-12 mt-3"">
                <label class="form-label">{{ $t('settings.contacts.contact_number') }}</label><span class="text-danger"> *</span>
                <base-input
                  :invalid="$v.formData.contact_number.$error"
                  v-model.trim="formData.contact_number"
                  type="number"
                  name="phone"
                  tab-index="4"
                  @input="$v.formData.contact_number.$touch()"
                />
                <div v-if="$v.formData.contact_number.$error">
                  <span v-if="!$v.formData.contact_number.required" class="text-danger">
                     {{ $tc('validation.Number_required') }}
                  </span>
                </div>
            </div>
            <div class="col-md-12 mt-3"">
                <label class="form-label">{{ $t('settings.contacts.designation') }}</label><span class="text-danger"> *</span>
                <base-input
                :invalid="$v.formData.designation.$error"
                  v-model.trim="formData.designation"
                  type="text"
                  tab-index="4"
                  @input="$v.formData.designation.$touch()"
                />
                <div v-if="$v.formData.designation.$error">
                  <span v-if="!$v.formData.designation.required" class="text-danger">
                     {{ $tc('validation.designation_required') }}
                  </span>
                </div>
            </div>  
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeContactModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          :disabled="isSubmitDisabled"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, maxLength, email, url, numeric,minValue,maxValue } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isEdit: false,
        isLoading: false,
        formData: {
          id:null,
          name: null,
          email: null,
          designation:null,
          contact_number:null
         
        },
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    isSubmitDisabled() {
      return this.$v.$invalid
    }
  },
  created(){
  },
 validations: {
      formData: {
        name: {
          required,
          minLength: minLength(3)
        },
        designation: {
          required,
        },
        contact_number : {
            required
        },
         email: {
          email,
          required
        },
      },
 },
  async mounted () {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('contact', [
      'addContact',
      'updateContact'
    ]),
    resetFormData () {  
      this.formData = {
          id:null,
          name: null,
          email: null,
          designation:null,
          contact_number:null,
      }
      this.$v.formData.$reset()
    },
    async submitContactData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      let  response;
      if (this.isEdit) {
        response = await this.updateContact(this.formData)
        if (response.data.result==true) { 
          window.toastr['success'](this.$t('settings.contacts.updated_message'))
          this.closeContactModal()
          return true
        }
        window.toastr['error'](response.data.error)
      } else {
        response = await this.addContact(this.formData)  
        if (response.data.result==true) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('settings.contacts.created_message'))
            this.closeContactModal()
            return true
          } 
          window.toastr['error'](response.data.error)
      }   
    },
    async setData () {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        email: this.modalData.email,
        contact_number: this.modalData.contact_number,
        designation: this.modalData.designation,
      }
    },
    closeContactModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
